function initDataTable(selector, url) {
    var table;

    if ($(selector).length && $.fn.DataTable) {
        if ($.fn.DataTable.isDataTable(selector)) {
            $(selector).DataTable().clear().destroy();
        }

        // Determine columns based on table type
        var isCompletedTable = selector === '#completeTaskTable';
        var columns = [
            // REQUIRED POSITION COLUMN (hidden)
            {
                data: "position",
                name: "position",
                visible: false,
                searchable: false
            },
            {
                data: null,
                name: "name",
                render: function(data) {
                    return data.fname + ' ' + data.lname;
                }
            },
            {
                data: "task_name",
                name: "task_name"
            },
            {
                data: "task_type",
                name: "task_type"
            },
            {
                data: "details",
                name: "details"
            },
            {
                data: "status",
                name: "status"
            },
            {
                data: "assigned_datetime",
                name: "assigned_datetime"
            }
        ];

        // Add completed_datetime column only for completed table
        if (isCompletedTable) {
            columns.push({
                data: "completed_datetime",
                name: "completed_datetime"
            });
        }

        // Add actions column
        columns.push({
            data: "actions",
            name: "actions",
            orderable: false,
            searchable: false
        });

        table = $(selector).DataTable({
            lengthMenu: [
                [25, 50, 100, -1],
                [25, 50, 100, "All"],
            ],
            responsive: true,

            // ENABLE ROW REORDER - exclude actions column from drag selector
            rowReorder: {
                selector: 'td:not(:last-child)'
            },

            pagingType: "full_numbers",
            processing: true,
            serverSide: true,
            ajax: url,
            columns: columns,
            rowId: 'id',
            drawCallback: function () {
                $(`${selector} tbody tr`).each(function () {
                    const rowData = $(selector).DataTable().row(this).data();
                    if (rowData && rowData.id) {
                        $(this).attr('data-id', rowData.id);
                    }
                });
            },
            initComplete: function () {
                const tableId = selector;
                const $lengthDiv = $(tableId + '_length');
                let $select = $('#employee_filter_select');

                // If select doesn't exist, create it
                if ($select.length === 0) {
                    $select = $(`
                        <select id="employee_filter_select" multiple style="width:200px; margin-left:15px;">
                            <!-- Options will be loaded from database -->
                        </select>
                    `);
                    $lengthDiv.after($select);

                    // Add styling only once
                    const css = `
                        <style>
                            #employee_filter_select + .select2-container {
                                width: 200px !important;
                            }
                            #employee_filter_select + .select2-container .select2-selection--multiple {
                                height: 38px !important;
                                min-height: 38px !important;
                                border: 1px solid #ced4da;
                                border-radius: 6px;
                                padding: 0 12px;
                                background: white;
                                font-size: 14px;
                            }
                            #employee_filter_select + .select2-container .select2-selection__rendered {
                                line-height: 36px !important;
                                color: #495057;
                                padding-left: 0 !important;
                            }
                            #employee_filter_select + .select2-container .select2-selection__choice {
                                display: none !important;
                            }
                        </style>
                    `;
                    $('head').append(css);

                    // Load employees only once
                    $.ajax({
                        url: '/tasks/get-employees',
                        method: 'GET',
                        dataType: 'json',
                        success: function(response) {
                            response.employees.forEach(emp => {
                                $select.append(`<option value="${emp.id}">${emp.fname} ${emp.lname}</option>`);
                            });
                            initializeEmployeeFilter();
                        },
                        error: function() {
                            $select.append('<option value="">Error loading employees</option>');
                            initializeEmployeeFilter();
                        }
                    });
                } else {
                    // Select already exists, just move it to the new table's length div
                    $select.detach();
                    $lengthDiv.after($select);

                    // Re-initialize Select2 for the new table context
                    if ($select.data('select2')) {
                        $select.select2('destroy');
                    }
                    initializeEmployeeFilter();
                }

                // Initialize Select2
                function initializeEmployeeFilter() {
                    $select.select2({
                        placeholder: "Select employees",
                        allowClear: true,
                        closeOnSelect: false,
                        width: '200px',
                        dropdownParent: $(tableId + '_wrapper'),
                        escapeMarkup: function(m) { return m; }
                    });

                    // Force update displayed text on every change
                    $select.off('select2:select select2:unselect select2:clear').on('select2:select select2:unselect select2:clear', function () {
                        const selected = $select.val() || [];
                        let displayText = "Select employees";

                        if (selected.length === 1) {
                            displayText = $select.find('option:selected').text().trim();
                        } else if (selected.length > 1) {
                            displayText = selected.length + " employees selected";
                        }

                        const $rendered = $select.next('.select2-container').find('.select2-selection__rendered');
                        $rendered.text(displayText);
                        if (selected.length === 0) {
                            $rendered.removeAttr('title');
                        } else {
                            $rendered.attr('title', displayText);
                        }
                    });

                    // Filtering logic - remove old handler and add new one
                    $select.off('change.tableFilter').on('change.tableFilter', function () {
                        const vals = $(this).val() || [];
                        if (vals.length > 0) {
                            const regex = vals.map(v => '^' + $.fn.dataTable.util.escapeRegex(v) + '$').join('|');
                            table.column(1).search(regex, true, false).draw();
                        } else {
                            table.column(1).search('').draw();
                        }
                    });

                    // Trigger initial display
                    $select.trigger('change');
                }
            }
        });

        // HANDLE REORDER
        table.on("row-reorder", function (e, diff, edit) {
            var order = [];

            $(`${selector} tbody tr`).each(function (index) {
                let id = $(this).attr("data-id");
                if (id) {
                    order.push({
                        id: id,
                        position: index + 1
                    });
                }
            });

            $.ajax({
                url: "/tasks/reorder",
                method: "POST",
                data: {
                    order: order,
                    _token: $('meta[name="csrf-token"]').attr("content"),
                },
                success: function (res) {
                    console.log("Order saved successfully", res);
                },
                error: function (xhr) {
                    console.error("Save failed", xhr.responseText);
                    table.ajax.reload();
                }
            });
        });
    }
}


function searchEmployee() {
    $("#ex-search").picker({
        search: true,
        texts: {
            trigger: "Select Employee",
            noResult: "No results",
            search: "Search",
        },
    });
}

function saveTask(url) {
    const taskForm = {};
    taskForm.employee_id = $("#employee_id").val();
    taskForm.task_type = $("#task_type").val();
    taskForm.tags = $("#task_tags").val();

    if ($("#free_form_task").val() && $("#details").val()) {
        taskForm.task = {
            task: $("#free_form_task").val(),
            details: $("#details").val(),
        };
    } else {
        taskForm.task = null;
    }

    taskForm.status = $("#task_status").val();
    taskForm.assigned_datetime = $("#assigned_datetime").val();

    // send request by ajax
    $.post(url, taskForm);
}

function updateTask(url) {
    const taskForm = {};
    taskForm.employee_id = $("#employee_id").val();
    taskForm.task_type = $("#task_type").val();
    taskForm.tags = $("#task_tags").val();
    taskForm.status = $("#task_status").val();
    taskForm.assigned_datetime = $("#assigned_datetime").val();

    if ($("#free_form_task").val() && $("#details").val()) {
        taskForm.task = {
            task: $("#free_form_task").val(),
            details: $("#details").val(),
        };
    } else {
        taskForm.task = null;
    }

    // send request by ajax
    $.ajax({
        url: url,
        method: "PUT",
        dataType: "json",
        data: taskForm,
    });
}

function taskType(data) {
    if (data == "FREE_FORM") {
        showFreeFormElements();
    }
}

function deleteTask(deleteUrl) {
    swal({
        title: "Do you want to delete this Task?",
        text: "You will not be able to recover this imaginary file!",
        icon: "error",
        buttons: {
            cancel: {
                text: "Cancel",
                value: null,
                visible: true,
                className: "btn btn-default",
                closeModal: true,
            },
            confirm: {
                text: "Delete",
                value: true,
                visible: true,
                className: "btn btn-danger",
                closeModal: true,
            },
        },
    }).then((result) => {
        if (result) {
            $.ajax({
                method: "delete",
                url: deleteUrl,
                success: function () {
                    location.reload();
                },
            });
        }
    });
}

function fetchTypeWiseTags(value) {
    if (value != "free_form") {
        $(".free_form_elements").addClass("d-none");

        $.ajax({
            url: `/tasks/${value}/tags`,
            dataType: "json",
            method: "GET",
            success: (data, msg) => {
                console.log(data);

                var availableTags = Object.values(data);

                $(".pre-div").removeClass("d-none");

                $("#task_tags").tagit({
                    availableTags: availableTags,
                    showAutocompleteOnFocus: true,
                    allowSpaces: true,
                    beforeTagAdded: function (event, ui) {
                        if (
                            $.inArray(
                                ui.tagLabel.toLowerCase(),
                                availableTags.map(function (tag) {
                                    return tag;
                                })
                            ) == -1
                        ) {
                            return true;
                        }
                        return true;
                    },
                });
            },
            error: (error) => {
                console.error("Error fetching tags:", error);
            },
        });
    } else {
        $(".free_form_elements").removeClass("d-none");
        $(".pre-div").addClass("d-none");
    }
}

// ==== Make functions global ====
window.searchEmployee = searchEmployee;
window.saveTask = saveTask;
window.updateTask = updateTask;
window.taskType = taskType;
window.deleteTask = deleteTask;
window.fetchTypeWiseTags = fetchTypeWiseTags;
window.initDataTable = initDataTable;
